import { config } from '@percent/workplace-giving/config/config'
import { OpportunityDetailDto, OpportunityLocationTypeDto } from '@percent/workplace-giving/api/opportunity/dto'
import { GetOpportunitiesListElement } from '@percent/workplace-giving/api/opportunity/getOpportunities/getOpportunities.types'
import { formatFullOfflineOpportunityAddress } from './formatOfflineOpportunityAddress'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'

export const OUTLOOK_OPPORTUNITY_ID_KEY = 'outlook-calendar-opportunity-id'

export const makeOpportunityPageLink = (opportunityId: string) => {
  return `${config.urls.appUrl}${AppRoute.OPPORTUNITY_DETAILS.replace(':opportunityId', opportunityId)}`
}

export const formatOpportunityDescription = (
  opportunity: Pick<OpportunityDetailDto, 'location' | 'description' | 'id'>,
  t: (key: string) => string
) => {
  const locationText = (() => {
    if (opportunity.location.type === OpportunityLocationTypeDto.Offline) {
      return `${t('workplace_giving.volunteering.calendar.location')} ${formatFullOfflineOpportunityAddress(
        opportunity
      )}`
    }

    if (opportunity.location.type === OpportunityLocationTypeDto.Virtual && opportunity.location.link) {
      return `${t('workplace_giving.volunteering.calendar.videoConferenceLink')} <a href="${
        opportunity.location.link
      }">${opportunity.location.link}</a>`
    }

    return undefined
  })()

  const calendarDescription = `
${locationText ?? ''}${
    locationText
      ? `

`
      : ''
  }${t('workplace_giving.volunteering.calendar.eventPage')} <a href="${makeOpportunityPageLink(
    opportunity.id
  )}">${makeOpportunityPageLink(opportunity.id)}</a>

${opportunity.description}`

  return calendarDescription
}

export const getOpportunityLocation = (opportunity: OpportunityDetailDto | GetOpportunitiesListElement) => {
  if (opportunity.location.type === OpportunityLocationTypeDto.Virtual && opportunity.location.link) {
    return opportunity.location.link
  }

  if (opportunity.location.type === OpportunityLocationTypeDto.Offline) {
    return formatFullOfflineOpportunityAddress(opportunity)
  }

  return undefined
}

export const getOpportunityDetailsForCalendar = (
  opportunity: OpportunityDetailDto | GetOpportunitiesListElement,
  t: (key: string) => string,
  timeZone?: string
) => ({
  opportunity: {
    opportunityId: opportunity.id,
    name: opportunity.name,
    description: formatOpportunityDescription(opportunity, t),
    startDate: opportunity.startDate ?? '',
    endDate: opportunity.endDate ?? '',
    timeZone,
    location: getOpportunityLocation(opportunity)
  }
})
